// extracted by mini-css-extract-plugin
export var wordContainer = "_s5-0";